import {SubjectTab} from '@esgi/main/libs/store';

export class SubjectCreatedEvent {
	constructor(public newSubject: SubjectTab) {}
}
